import React from "react";
import RpaConfigurationBrowser from "./components/RpaConfigurationBrowser";
import "./rpaConfiguration.scss";

const RpaConfiguration: React.FC = () => {
  return (
    <div className="rpa-configuration">
      <div className="rpa-configuration__content">
        <RpaConfigurationBrowser />
      </div>
    </div>
  );
};

export default RpaConfiguration;
